import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../utils/helpers";

const updateVisitExternalVideoTypes = async ({ visitId, ids, isAllExternalVideos }) => {
  const token = localStorage.getItem("token");

  const payload = { external_video_type_ids: ids };
  if (isAllExternalVideos !== undefined) payload.is_all_external_videos = isAllExternalVideos;

  const res = await axios.put(
    `${__API_URL__}/api/photos/visits/${visitId}/external-video-types/`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useUpdateVisitExternalVideoTypesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVisitExternalVideoTypes,
    onSuccess: () => {
      toast.success("External video types updated");
      queryClient.invalidateQueries({ queryKey: ["visit_external_video_types"] });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update external video types");
    },
  });
};

export default useUpdateVisitExternalVideoTypesMutation;
